export const SUPPORTED_DATE_FORMATS = [
    'YYYY-MM-DD',
    'YYYY/MM/DD',
    'YYYY MM DD',
    'YYYY-MM-DD HH:mm',
    'YYYY/MM/DD HH:mm',
    'YYYY MM DD HH:mm',
    'YYYY-MM-DD HH:mm:ss',
    'YYYY/MM/DD HH:mm:ss',
    'YYYY MM DD HH:mm:ss',
];

export const HEADER_PREFIX = 'X-UIPATH';

export const LOCALIZATION_PARAM_NAME = 'Localization';
export const FOLDER_PARAM_NAME = 'OrganizationUnitId';

export const LOCALIZATION_HEADER_NAME = `${HEADER_PREFIX}-${LOCALIZATION_PARAM_NAME}`;
export const FOLDER_HEADER_NAME = `${HEADER_PREFIX}-${FOLDER_PARAM_NAME}`;
